var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsOptional, IsString, IsUUID } from 'class-validator';
export class OfficeLocationDeviceFullSizeDto {
    id;
    officeLocationId;
    officeId;
    name;
    description;
    deviceType;
    serialNumber;
    manufacturer;
    model;
    isActive;
    createdAt;
    updatedAt;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDeviceFullSizeDto.prototype, "id", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDeviceFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDeviceFullSizeDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeLocationDeviceFullSizeDto.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeLocationDeviceFullSizeDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeLocationDeviceFullSizeDto.prototype, "deviceType", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeLocationDeviceFullSizeDto.prototype, "serialNumber", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeLocationDeviceFullSizeDto.prototype, "manufacturer", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeLocationDeviceFullSizeDto.prototype, "model", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], OfficeLocationDeviceFullSizeDto.prototype, "isActive", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationDeviceFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationDeviceFullSizeDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=office-location-device.full-size.dto.js.map